/**
 * The permission codes of the reference's group checklist that no 212Ez screen uses yet. The walk
 * of 2026-10-27 read 738 codes in 18 groups; the others are in `PERMISSIONS` with their own
 * descriptions. These are listed so a group can be set up as on the reference; ticking one has no
 * effect until the feature that checks it is built. Names are the reference's, less its vendor's
 * name; the group is the catalogue category of the reference group they sit in.
 */
export const REFERENCE_ONLY_PERMISSIONS: ReadonlyArray<
  readonly [code: number, name: string, category: string]
> = [
  [172, 'Dashboard Dispatched Suspended subscribers by Master', 'Dashboard'],
  [989, 'Assurance Resources & Contacts', 'Dashboard'],
  [118, 'Resend Phone', 'Customer Service'],
  [378, 'Other Information', 'Customer Service'],
  [464, 'Detailed Transaction', 'Customer Service'],
  [511, 'Search by SSN in CSR', 'Customer Service'],
  [512, 'Search by DOB in CSR', 'Customer Service'],
  [602, 'Check Dealer Wallet balance', 'Customer Service'],
  [603, 'Manage Processing Fee Dealer Wallet', 'Customer Service'],
  [605, 'Domestic Minutes', 'Customer Service'],
  [608, 'Display Account Number', 'Customer Service'],
  [651, 'Pay Bill Echeck', 'Customer Service'],
  [653, 'Echeck Log', 'Customer Service'],
  [822, 'Allow Search Model for All Carrier Permission', 'Customer Service'],
  [824, 'Pay Bill for Money Order', 'Customer Service'],
  [853, 'Delete Invoice', 'Customer Service'],
  [949, 'IVR Credit Card Payment Plan Purchase', 'Customer Service'],
  [987, 'Allow ACP Transfer Exception', 'Customer Service'],
  [1011, 'Early Payments', 'Customer Service'],
  [1017, 'Provision Failed Orders', 'Customer Service'],
  [1041, 'Bypass USPS address validation', 'Customer Service'],
  [1042, 'Account Status connection type Electronically', 'Customer Service'],
  [1043, 'Account Status connection type Non-Electronically', 'Customer Service'],
  [1048, 'Upgrade To Family Plan Add Existing Customer', 'Customer Service'],
  [1050, 'Buy Insurance', 'Customer Service'],
  [1051, 'Cancel Insurance', 'Customer Service'],
  [1052, 'Loyalty Reward program', 'Customer Service'],
  [1053, 'Change Insurance', 'Customer Service'],
  [1055, 'Manage Credit Limit', 'Customer Service'],
  [1059, 'Bulk NLAD Verify ACP', 'Customer Service'],
  [1079, 'NLAD Outage Report', 'Customer Service'],
  [1084, 'Generic-change activation type', 'Customer Service'],
  [1086, 'Refund Wallet', 'Customer Service'],
  [1089, 'Make Parent', 'Customer Service'],
  [1090, 'Remove Line', 'Customer Service'],
  [
    1097,
    'Allow user to process with New device in case of device error during handover',
    'Customer Service',
  ],
  [
    1098,
    'Allow user to process device with retail price in case of device error during handover',
    'Customer Service',
  ],
  [1103, 'Stop sending mdn to nlad ebb', 'Customer Service'],
  [1109, 'Activation Carrier Log', 'Customer Service'],
  [1110, 'Change ESN Carrier Log', 'Customer Service'],
  [1111, 'Change Plan Carrier Log', 'Customer Service'],
  [1122, 'Do Not Allow SIM Option for Agent', 'Customer Service'],
  [1123, 'Allow agent to sim swap on enrollment portal', 'Customer Service'],
  [1128, 'Disable password edit permission for Agent', 'Customer Service'],
  [1129, 'Disable PIN edit permission for Agent', 'Customer Service'],
  [1134, 'ACP Recertification Subscriber Uploads', 'Customer Service'],
  [1144, 'Allow user to update Application Id', 'Customer Service'],
  [1145, 'Allow user to update Subscriber Id', 'Customer Service'],
  [1160, 'Wallet Cheque Payment', 'Customer Service'],
  [1184, 'Allow Purchase Insurance For prepaid', 'Customer Service'],
  [1190, 'Bulk Add Lifeline Child Process', 'Customer Service'],
  [1192, 'Bulk acp to lifeline ca process', 'Customer Service'],
  [1193, 'Estimated Charges Overview', 'Customer Service'],
  [1199, 'Enable schedule disconnection date feature', 'Customer Service'],
  [1202, 'Enable permission chain base search in CSR', 'Customer Service'],
  [1204, 'Enable REST API Block Permission', 'Customer Service'],
  [1208, 'SIM Lock', 'Customer Service'],
  [1212, 'Rest API Monitoring', 'Customer Service'],
  [1216, 'Add Wifi Calling', 'Customer Service'],
  [1217, 'Add Data Throttle', 'Customer Service'],
  [1222, 'Bulk Prepaid To Lifeline Process', 'Customer Service'],
  [1224, 'Get eSIM Status', 'Customer Service'],
  [1376, 'Skip Payment in purchase insurance', 'Customer Service'],
  [1310, 'View Portin', 'Ports'],
  [1311, 'Check Portin Status', 'Ports'],
  [1312, 'Cancel Portin', 'Ports'],
  [1313, 'Add Notes', 'Ports'],
  [1314, 'Cancel & Resubmit Port-in', 'Ports'],
  [1315, 'Async Response', 'Ports'],
  [1332, 'Equipment Purchase Report', 'Ports'],
  [380, 'Skip Activation Fee', 'Orders'],
  [1124, 'Bulk update billing code', 'Orders'],
  [1138, 'Bulk Update Billing Code TMB Carrier', 'Orders'],
  [1169, 'Allow To View Details In All Lists', 'Orders'],
  [1173, 'Quotes', 'Orders'],
  [1174, 'New Iot Orders', 'Orders'],
  [1175, 'All Orders', 'Orders'],
  [1176, 'Completed Orders', 'Orders'],
  [1177, 'Incomplete Orders', 'Orders'],
  [1178, 'Provision Status', 'Orders'],
  [1179, 'Switch Iot Orders Parent', 'Orders'],
  [1319, 'Manage Frontend Login Restriction', 'Orders'],
  [1320, 'Delete User Group Permission', 'Orders'],
  [1370, 'Set wallet limit', 'Orders'],
  [218, 'Review Orders', 'Review'],
  [481, 'Activation Dashboard Quick Stats', 'Review'],
  [482, 'Activation Dashboard Subscribers by State', 'Review'],
  [483, 'Activation Dashboard Approved Rejected Pending 2017', 'Review'],
  [484, 'Activation Dashboard Total Rejected Subscribers by Reason', 'Review'],
  [485, 'Activation Dashboard Total subscribers by Master Agent', 'Review'],
  [813, 'Review Edit Image', 'Review'],
  [1151, 'California Soft Denials Pending', 'Review'],
  [2, 'Single Upload', 'Inventory'],
  [3, 'Bulk Upload', 'Inventory'],
  [4, 'Load Pre-activated units', 'Inventory'],
  [5, 'Load not-provisioned units', 'Inventory'],
  [6, 'Load for Provisioning', 'Inventory'],
  [20, 'Inventory Load report', 'Inventory'],
  [167, 'Upgrade Phone', 'Inventory'],
  [168, 'Resend Phone', 'Inventory'],
  [176, 'AddModel', 'Inventory'],
  [181, 'Clear ESN Report', 'Inventory'],
  [184, 'MDN Plan Change Report', 'Inventory'],
  [186, 'Shipper Batch Report', 'Inventory'],
  [228, 'Search ESN Device', 'Inventory'],
  [271, 'Change Equipment Report', 'Inventory'],
  [384, 'Add Stock', 'Inventory'],
  [439, 'Change ESN Status And Agent Name Report', 'Inventory'],
  [440, 'Bulk Reprovision ESN SIM Report', 'Inventory'],
  [497, 'Not Provision Report', 'Inventory'],
  [545, 'Add Model SKU', 'Inventory'],
  [633, 'Scan ESN/DEVICE Report', 'Inventory'],
  [849, 'BULK NLAD STATUS CHECK REPORT', 'Inventory'],
  [944, 'Bulk Reconnect Process', 'Inventory'],
  [977, 'Bulk import suspend restore', 'Inventory'],
  [1065, 'Reverse payment in invoice payment', 'Inventory'],
  [1132, 'Website Tag Management', 'Inventory'],
  [1269, 'Bulk Customer Rollback', 'Inventory'],
  [536, 'Shipment Phone Replacement', 'Shipment'],
  [537, 'Shipment Resend Phone Request', 'Shipment'],
  [196, 'Customers Escalation Note', 'Reports'],
  [691, 'Agent Plan Permission Report', 'Reports'],
  [942, 'Incomplete Enrollment Non Lifeline Report', 'Reports'],
  [1037, 'Equifax Report', 'Reports'],
  [1039, 'Wallet Payment transfer', 'Reports'],
  [1073, 'Export CSV for review queue', 'Reports'],
  [198, 'Generate Pin', 'Pin Management'],
  [199, 'Validate Pin', 'Pin Management'],
  [200, 'Update Pin', 'Pin Management'],
  [201, 'Manage Batch', 'Pin Management'],
  [202, 'Manage Lot', 'Pin Management'],
  [203, 'Email Recipient List', 'Pin Management'],
  [204, 'Change Zip Password', 'Pin Management'],
  [660, 'Manage Denominations', 'Pin Management'],
  [661, 'Manage Old Pins', 'Pin Management'],
  [662, 'Add New Denomination', 'Pin Management'],
  [751, 'PIN Re-assign By Agent', 'Pin Management'],
  [752, 'Lot Re-assign By Agent', 'Pin Management'],
  [753, 'PIN Report', 'Pin Management'],
  [754, 'Closing Stock Transaction', 'Pin Management'],
  [755, 'PIN Re-assign Report', 'Pin Management'],
  [756, 'PIN Wise Transaction Report', 'Pin Management'],
  [758, 'PIN Assign Report', 'Pin Management'],
  [1309, 'Bulk PIN Upload', 'Pin Management'],
  [205, 'New Sale', 'POS'],
  [206, 'Minute/Text Topup', 'POS'],
  [207, 'Data Topup', 'POS'],
  [208, 'Change ESN/SIM', 'POS'],
  [209, 'Change Mobile Number', 'POS'],
  [210, 'Change Device', 'POS'],
  [211, 'Change Plan', 'POS'],
  [212, 'Renew Plan', 'POS'],
  [213, 'Pay Bill', 'POS'],
  [564, 'Prepaid Postpaid Order', 'POS'],
  [565, 'POS RMA Process', 'POS'],
  [567, 'POS Sale Return', 'POS'],
  [575, 'Manage Opening Stock', 'POS'],
  [576, 'Manage Purchases', 'POS'],
  [577, 'Manage Sales', 'POS'],
  [578, 'Manage Categories', 'POS'],
  [579, 'Manage Products', 'POS'],
  [580, 'Manage Discounts', 'POS'],
  [581, 'Manage Vendors', 'POS'],
  [582, 'Manage Registers', 'POS'],
  [583, 'Manage Reports', 'POS'],
  [584, 'Manage Purchase Return', 'POS'],
  [585, 'Closing Stock Report', 'POS'],
  [586, 'Non Serialized Product Tracking', 'POS'],
  [587, 'Serialized Product Tracking ESN OR SIM OR Device Id', 'POS'],
  [588, 'Register Open Close', 'POS'],
  [589, 'Register Status', 'POS'],
  [590, 'Register Transactions', 'POS'],
  [591, 'Transaction Report', 'POS'],
  [592, 'Item Wise Opening Stock', 'POS'],
  [593, 'Item Wise Purchase', 'POS'],
  [594, 'Item Wise Sale', 'POS'],
  [595, 'Item Wise Sale Return', 'POS'],
  [596, 'Accounts Receivable Aging', 'POS'],
  [597, 'Accounts Payable Aging', 'POS'],
  [611, 'Manage Countries', 'POS'],
  [612, 'Manage Providers', 'POS'],
  [613, 'Manage ILD Vendors', 'POS'],
  [614, 'Manage Offerings', 'POS'],
  [615, 'DollarPhone Topup', 'POS'],
  [616, 'DollarPhone ILD Topup', 'POS'],
  [627, 'Denominations in Sale Checkout Page', 'POS'],
  [663, 'Manage Plans', 'POS'],
  [681, 'POS XML Log', 'POS'],
  [682, 'POS Recharge History', 'POS'],
  [881, 'Employee Login Time Sheet', 'POS'],
  [886, 'Validate Byod Device', 'POS'],
  [432, 'XML Error Definition', 'APIs'],
  [433, 'XML APIs', 'APIs'],
  [533, 'Add New SMS Rule', 'Lifecycle SMS'],
  [534, 'View All SMS Rule', 'Lifecycle SMS'],
  [1237, 'Add View Dealer Notification', 'Notifications'],
  [728, 'Ticketing System Admin', 'Tickets'],
  [747, 'Add Edit Ticket Group', 'Tickets'],
  [1120, 'Assign Ticket To User', 'Tickets'],
  [1121, 'Assign Ticket To Group', 'Tickets'],
  [323, 'Tablet LL Enrollment', 'Tablet'],
  [324, 'Tablet Prepaid Enrollment', 'Tablet'],
  [325, 'Tablet Show google Map', 'Tablet'],
  [326, 'Tablet Topup', 'Tablet'],
  [327, 'Tablet Data Topup', 'Tablet'],
  [328, 'Tablet Billpay', 'Tablet'],
  [332, 'Tablet Event Order Customer', 'Tablet'],
  [333, 'Tablet Skip Activation Fee', 'Tablet'],
  [334, 'Tablet NO Email Permission', 'Tablet'],
  [335, 'Tablet Change Equipment', 'Tablet'],
  [573, 'NLAD Address Override Rural and Tribal', 'Tablet'],
  [640, 'Scan Inventory', 'Tablet'],
  [647, 'Allow BYOD ESN/Device Swap', 'Tablet'],
  [730, 'Tablet Recertification', 'Tablet'],
  [776, 'Phone Request', 'Tablet'],
  [854, 'Tablet Home Phone Icon', 'Tablet'],
  [855, 'Tablet Upload Proof Icon', 'Tablet'],
  [749, 'Revenue', 'Revenue'],
  [8, 'View Dropship orders', 'Miscellaneous'],
  [9, 'Fullfill Dropship Orders', 'Miscellaneous'],
  [10, 'Bulk Processing', 'Miscellaneous'],
  [11, 'MDN plan change', 'Miscellaneous'],
  [13, 'Deenroll ESN/SIM', 'Miscellaneous'],
  [14, 'Add Service Areas', 'Miscellaneous'],
  [15, 'Display All Service Areas Add Service Areas', 'Miscellaneous'],
  [16, 'Edit Service Area', 'Miscellaneous'],
  [17, 'MDN change', 'Miscellaneous'],
  [25, 'Hotline Phones', 'Miscellaneous'],
  [26, 'Unhotline Phones', 'Miscellaneous'],
  [33, 'User Activity Log', 'Miscellaneous'],
  [34, 'View Proof', 'Miscellaneous'],
  [37, 'Deactivation Report', 'Miscellaneous'],
  [39, 'Deenroll Report', 'Miscellaneous'],
  [41, 'Customer Eligibility', 'Miscellaneous'],
  [42, 'Subscriber Density by Zip', 'Miscellaneous'],
  [43, 'Usage Report', 'Miscellaneous'],
  [45, 'Disconnection', 'Miscellaneous'],
  [46, 'Customer Report', 'Miscellaneous'],
  [48, 'Order Summary Report', 'Miscellaneous'],
  [52, 'Price update', 'Miscellaneous'],
  [53, 'Payment Failure Report', 'Miscellaneous'],
  [54, 'Other updates', 'Miscellaneous'],
  [62, 'Check Pin Status', 'Miscellaneous'],
  [70, 'NLAD Stats', 'Miscellaneous'],
  [73, 'History Report', 'Miscellaneous'],
  [74, 'Android GPS/Locations', 'Miscellaneous'],
  [78, 'Add Service', 'Miscellaneous'],
  [79, 'Display All Services', 'Miscellaneous'],
  [82, 'Add New Plan', 'Miscellaneous'],
  [84, 'Display All Plan', 'Miscellaneous'],
  [85, 'Add Reload Amount', 'Miscellaneous'],
  [86, 'Display Reload Amount', 'Miscellaneous'],
  [88, 'Add Custom Plan', 'Miscellaneous'],
  [89, 'Display Custom Plan', 'Miscellaneous'],
  [91, 'Add Promo Plan', 'Miscellaneous'],
  [93, 'Display Promo Plan', 'Miscellaneous'],
  [94, 'Add Disconnection Reason', 'Miscellaneous'],
  [96, 'Display Disconnection Reason', 'Miscellaneous'],
  [104, 'Skip Tpiv Doc', 'Miscellaneous'],
  [105, 'NLAD TPIV FAIL Attempt', 'Miscellaneous'],
  [106, 'Enrollment Permission', 'Miscellaneous'],
  [107, 'Pre-paid enrollments', 'Miscellaneous'],
  [110, 'Handover', 'Miscellaneous'],
  [113, 'Telesales Enrollment', 'Miscellaneous'],
  [114, 'Deactivate MDN', 'Miscellaneous'],
  [115, 'View Customer Info', 'Miscellaneous'],
  [116, 'Sales Report', 'Miscellaneous'],
  [117, 'Topups', 'Miscellaneous'],
  [119, 'Plans', 'Miscellaneous'],
  [124, 'Reset Password', 'Miscellaneous'],
  [147, 'Last 4 day active Report', 'Miscellaneous'],
  [148, 'Disconnection Regular', 'Miscellaneous'],
  [177, 'Clear ESN', 'Miscellaneous'],
  [178, 'Clear Device', 'Miscellaneous'],
  [179, 'Check ESN OwnerShip', 'Miscellaneous'],
  [193, 'Agent Disconnection Report', 'Miscellaneous'],
  [195, 'Agent Compensation Report', 'Miscellaneous'],
  [216, 'Manage agent admin', 'Miscellaneous'],
  [217, 'Pin Lookup', 'Miscellaneous'],
  [225, 'Callcenter Pending Orders', 'Miscellaneous'],
  [229, 'Household Limit', 'Miscellaneous'],
  [231, 'Agent Bill Payment', 'Miscellaneous'],
  [235, 'Carriers', 'Miscellaneous'],
  [241, 'System Setting menu', 'Miscellaneous'],
  [249, 'looked at proof', 'Miscellaneous'],
  [255, 'Admin User', 'Miscellaneous'],
  [266, 'Existing Customer PortIn', 'Miscellaneous'],
  [336, 'IS Review Order', 'Miscellaneous'],
  [337, 'Show Permission Code', 'Miscellaneous'],
  [376, 'Data Plan Access', 'Miscellaneous'],
  [385, 'Reprovision', 'Miscellaneous'],
  [403, 'Close Ticket', 'Miscellaneous'],
  [405, 'Upgrade Topup Cash', 'Miscellaneous'],
  [406, 'Upgrade Topup Money Order', 'Miscellaneous'],
  [407, 'Upgrade Topup Wallet', 'Miscellaneous'],
  [408, 'Equipment Purchase CC', 'Miscellaneous'],
  [413, 'Upgrade Topup Money Gram', 'Miscellaneous'],
  [420, 'Add Data CC', 'Miscellaneous'],
  [425, 'Add Data Courtesy', 'Miscellaneous'],
  [430, 'More', 'Miscellaneous'],
  [434, 'De Provision Unused ESN SIM Report', 'Miscellaneous'],
  [435, 'Deactivate ESN Report', 'Miscellaneous'],
  [438, 'Set Device Status Report', 'Miscellaneous'],
  [441, 'Hex Decimal Converter ESN Report', 'Miscellaneous'],
  [442, 'in bulk process inventory', 'Miscellaneous'],
  [446, 'Existing Customer PortIn List', 'Miscellaneous'],
  [452, 'Proof Decrypt', 'Miscellaneous'],
  [469, 'Recertification Audit', 'Miscellaneous'],
  [470, 'View Employee', 'Miscellaneous'],
  [471, 'Edit Employee', 'Miscellaneous'],
  [472, 'Scan ESN Box ID', 'Miscellaneous'],
  [473, 'Scan Device Box ID', 'Miscellaneous'],
  [474, 'Manage user level access', 'Miscellaneous'],
  [475, 'ESN SIM Reprovision Batch Report', 'Miscellaneous'],
  [498, 'Line Enquiry Autoload', 'Miscellaneous'],
  [499, 'Live Status', 'Miscellaneous'],
  [514, 'Shipper ID', 'Miscellaneous'],
  [516, 'RMA Vendor', 'Miscellaneous'],
  [517, 'Batch Vendor RMA Status', 'Miscellaneous'],
  [525, 'Display Caller Id On Add Notes', 'Miscellaneous'],
  [526, 'Show Mailing Address in prepaid or postpaid Enrollment', 'Miscellaneous'],
  [539, 'Driving Licence TextField in Enrollment', 'Miscellaneous'],
  [541, 'NLAD Address Override Rural Tribal', 'Miscellaneous'],
  [542, 'Add More Lifeline Order', 'Miscellaneous'],
  [547, 'Melissa Suggesting', 'Miscellaneous'],
  [548, 'Vacant Address', 'Miscellaneous'],
  [549, 'NLAD verification override TPIV Port Freeze', 'Miscellaneous'],
  [554, 'Allow BYOD ESN/Device Swap', 'Miscellaneous'],
  [556, 'Hide Extra Add Unit Fields.', 'Miscellaneous'],
  [570, 'PayLater Payment Handover', 'Miscellaneous'],
  [601, 'Inventory Report Wholesale Cost Visibility', 'Miscellaneous'],
  [623, 'Manage Plan Type', 'Miscellaneous'],
  [624, 'Assign/Change Plan Type', 'Miscellaneous'],
  [625, 'Bulk Migration Upload', 'Miscellaneous'],
  [626, 'Bulk Migration Upload Report', 'Miscellaneous'],
  [634, 'Scan ESN/DEVICE with Box', 'Miscellaneous'],
  [635, 'Add Minutes eCheck/ACH', 'Miscellaneous'],
  [641, 'Add Data eCheck/ACH', 'Miscellaneous'],
  [642, 'Inventory Setup User Level', 'Miscellaneous'],
  [643, 'LifeLine Solix API Orders', 'Miscellaneous'],
  [658, 'Add New Battery', 'Miscellaneous'],
  [659, 'Add New Charger', 'Miscellaneous'],
  [672, 'Display date format tooltip permission', 'Miscellaneous'],
  [680, 'Add and Update Equipment', 'Miscellaneous'],
  [684, 'Add And Update Equipment Type', 'Miscellaneous'],
  [686, 'Add New Accessories', 'Miscellaneous'],
  [688, 'Serialized Log Report', 'Miscellaneous'],
  [689, 'Equipment List Log Report', 'Miscellaneous'],
  [690, 'Product Serialized Batch Report', 'Miscellaneous'],
  [694, 'Set Postpaid Credit Limit', 'Miscellaneous'],
  [707, 'Postpaid Invoices', 'Miscellaneous'],
  [708, 'Postpaid Invoices Credit Notes or Discount', 'Miscellaneous'],
  [714, 'Shipment Report For All Shipper', 'Miscellaneous'],
  [715, 'Postpaid Deposit Log', 'Miscellaneous'],
  [723, 'Deactivate MDN Non Electronic', 'Miscellaneous'],
  [725, 'Resend Phone Plus Equipment Purchase', 'Miscellaneous'],
  [733, 'Update Change Reason CSR', 'Miscellaneous'],
  [736, 'Scan ESN/DEVICE with Box Number', 'Miscellaneous'],
  [737, 'NLAD Process Type', 'Miscellaneous'],
  [741, 'View Report Of SOC Assign', 'Miscellaneous'],
  [745, 'SMS Password', 'Miscellaneous'],
  [746, 'SMS Balance Details', 'Miscellaneous'],
  [757, 'Sync Plan Expiry date on CSR', 'Miscellaneous'],
  [769, 'PIN Payment Handover', 'Miscellaneous'],
  [775, 'Manage User Level Access on Handover', 'Miscellaneous'],
  [784, 'Reactivate ESN CSR', 'Miscellaneous'],
  [820, 'TPIV HHWS Resolution', 'Miscellaneous'],
  [821, 'TPIV Other Resolution', 'Miscellaneous'],
  [827, 'Enable Enrollment Portal Access', 'Miscellaneous'],
  [829, 'Cancel Customer', 'Miscellaneous'],
  [838, 'Homephone Submitted Order', 'Miscellaneous'],
  [839, 'Homephone Bulk Process', 'Miscellaneous'],
  [840, 'Homephone CSI Inquiry', 'Miscellaneous'],
  [841, 'Other Payment Option', 'Miscellaneous'],
  [850, 'Modify Postpaid Charges', 'Miscellaneous'],
  [851, 'Run Enroll OR Transfer', 'Miscellaneous'],
  [860, 'Pay invoice Paypal', 'Miscellaneous'],
  [861, 'Add Data Topup PayPal', 'Miscellaneous'],
  [862, 'Add Wallet PayPal', 'Miscellaneous'],
  [863, 'Account Status PayPal', 'Miscellaneous'],
  [864, 'Paypal Payment Handover', 'Miscellaneous'],
  [865, 'Plan Purchase Through Paypal', 'Miscellaneous'],
  [866, 'Purchase Equipment Through Paypal', 'Miscellaneous'],
  [867, 'Swap Mdn Payment Through Paypal', 'Miscellaneous'],
  [876, 'Postpaid Customer Disconnection Notice Log', 'Miscellaneous'],
  [880, 'Allow User Access Level Chain In Prepaid Enrollments', 'Miscellaneous'],
  [887, 'Homephone Prospect Order', 'Miscellaneous'],
  [888, 'Download and Send Email Payment Receipt', 'Miscellaneous'],
  [893, 'Merge Ad hoc Invoice', 'Miscellaneous'],
  [899, 'Add Wallet through Topup Card', 'Miscellaneous'],
  [906, 'BYOS Handover', 'Miscellaneous'],
  [909, 'Ani Network Subscription', 'Miscellaneous'],
  [912, 'Inactive Modify', 'Miscellaneous'],
  [914, 'Delete Inactive Account', 'Miscellaneous'],
  [917, 'Bulk Carrier Change Report', 'Miscellaneous'],
  [933, 'US Payment', 'Miscellaneous'],
  [934, 'FISERV', 'Miscellaneous'],
  [941, 'Complete Portin Manual', 'Miscellaneous'],
  [953, 'SKIP LATE FEE', 'Miscellaneous'],
  [954, 'SKIP RESTORE FEE', 'Miscellaneous'],
  [955, 'ALLOW AUTOPAY DISCOUNT', 'Miscellaneous'],
  [958, 'IVR Credit Card Payment For add top up', 'Miscellaneous'],
  [959, 'IVR Credit Card Payment For add data top up', 'Miscellaneous'],
  [964, 'Failed Order Report', 'Miscellaneous'],
  [975, 'Sales Summary Report', 'Miscellaneous'],
  [976, 'Credit Card Batch Report', 'Miscellaneous'],
  [980, 'Plan Auto pay Credit Card Attempts Report', 'Miscellaneous'],
  [1020, 'Tax Exemption', 'Miscellaneous'],
  [1094, 'Allow user to access Google Authentication', 'Miscellaneous'],
  [1095, 'Create new group by copy existing group', 'Miscellaneous'],
  [1096, 'Allow user to replace group permissions', 'Miscellaneous'],
  [1115, 'Allow Change Agent Status', 'Miscellaneous'],
  [1143, 'Integrations - API', 'Miscellaneous'],
  [1187, 'BLUECONNECTSATT Pending Portout', 'Miscellaneous'],
  [1188, 'BLUECONNECTSATT Completed Portout', 'Miscellaneous'],
  [1201, 'Portout lock', 'Miscellaneous'],
  [1223, 'Bulk Add Employee', 'Miscellaneous'],
  [1244, 'Allow access to all commission matrices', 'Miscellaneous'],
  [1261, 'Pay Through Link', 'Miscellaneous'],
];
